import { forwardRef } from 'react';

export const MultifamilyHouseIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.97827 14.8147C2.97827 14.4984 3.23469 14.2419 3.551 14.2419H38.1437C38.46 14.2419 38.7165 14.4984 38.7165 14.8147V33.791C38.7165 34.1073 38.46 34.3638 38.1437 34.3638H3.551C3.23469 34.3638 2.97827 34.1073 2.97827 33.791V14.8147ZM4.12373 15.3874V33.2183H37.571V15.3874H4.12373Z"
        />
        <path d="M6.07092 5.15454L1.83274 13.6691L1.79456 14.7764H12.0273V12.2182L20.8473 5.72727L29.7819 12.2182V14.7764H40.6637L40.6255 13.6691L36.3873 5.15454H6.07092Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.55829 4.8993C5.65512 4.70477 5.85371 4.58179 6.07101 4.58179H36.3874C36.6047 4.58179 36.8033 4.70477 36.9001 4.8993L41.1383 13.4138C41.1748 13.4872 41.1951 13.5675 41.1979 13.6493L41.2361 14.7566C41.2415 14.9118 41.1836 15.0626 41.0756 15.1743C40.9677 15.286 40.8191 15.3491 40.6637 15.3491H29.7819C29.4656 15.3491 29.2092 15.0926 29.2092 14.7763V12.51L20.8496 6.43674L12.6001 12.5078V14.7763C12.6001 15.0926 12.3437 15.3491 12.0274 15.3491H1.79465C1.63933 15.3491 1.49067 15.286 1.38275 15.1743C1.27483 15.0626 1.21691 14.9118 1.22226 14.7566L1.26045 13.6493C1.26327 13.5675 1.28361 13.4872 1.32011 13.4138L5.55829 4.8993ZM6.42569 5.72724L2.40094 13.813L2.38747 14.2036H11.4547V12.2182C11.4547 12.0361 11.5413 11.8648 11.6879 11.7569L19.8811 5.72724H6.42569ZM21.8218 5.72724H36.0327L40.0575 13.813L40.0709 14.2036H30.3547V12.2182C30.3547 12.0348 30.2669 11.8626 30.1186 11.7548L21.8218 5.72724Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5091 4.80705C20.7087 4.66102 20.9794 4.65958 21.1805 4.80347L30.5733 11.5235C30.7236 11.631 30.8127 11.8045 30.8127 11.9893V14.3184C30.8127 14.6347 30.5563 14.8911 30.24 14.8911C29.9237 14.8911 29.6673 14.6347 29.6673 14.3184V12.2837L20.8511 5.97617L12.0273 12.4326V14.3184C12.0273 14.6347 11.7709 14.8911 11.4546 14.8911C11.1383 14.8911 10.8818 14.6347 10.8818 14.3184V12.142C10.8818 11.9593 10.969 11.7876 11.1164 11.6798L20.5091 4.80705Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8618 17.9072C18.8618 17.5909 19.1182 17.3345 19.4345 17.3345H22.7945C23.1109 17.3345 23.3673 17.5909 23.3673 17.9072V22.1072C23.3673 22.4235 23.1109 22.6799 22.7945 22.6799H19.4345C19.1182 22.6799 18.8618 22.4235 18.8618 22.1072V17.9072ZM20.0073 18.4799V21.5345H22.2218V18.4799H20.0073Z"
        />
        <path d="M22.7946 9.50732H19.4346V12.5619H22.7946V9.50732Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8618 9.5073C18.8618 9.19099 19.1182 8.93457 19.4345 8.93457H22.7945C23.1109 8.93457 23.3673 9.19099 23.3673 9.5073V12.5618C23.3673 12.8782 23.1109 13.1346 22.7945 13.1346H19.4345C19.1182 13.1346 18.8618 12.8782 18.8618 12.5618V9.5073ZM20.0073 10.08V11.9891H22.2218V10.08H20.0073Z"
        />
        <path d="M28.9037 17.9072H25.5437V22.1072H28.9037V17.9072Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.9709 17.9072C24.9709 17.5909 25.2274 17.3345 25.5437 17.3345H28.9037C29.22 17.3345 29.4764 17.5909 29.4764 17.9072V22.1072C29.4764 22.4235 29.22 22.6799 28.9037 22.6799H25.5437C25.2274 22.6799 24.9709 22.4235 24.9709 22.1072V17.9072ZM26.1164 18.4799V21.5345H28.3309V18.4799H26.1164Z"
        />
        <path d="M22.7946 25.1235H19.4346V29.3235H22.7946V25.1235Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8618 25.1238C18.8618 24.8074 19.1182 24.551 19.4345 24.551H22.7945C23.1109 24.551 23.3673 24.8074 23.3673 25.1238V29.3238C23.3673 29.6401 23.1109 29.8965 22.7945 29.8965H19.4345C19.1182 29.8965 18.8618 29.6401 18.8618 29.3238V25.1238ZM20.0073 25.6965V28.751H22.2218V25.6965H20.0073Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.9709 25.1238C24.9709 24.8074 25.2274 24.551 25.5437 24.551H28.9037C29.22 24.551 29.4764 24.8074 29.4764 25.1238V29.3238C29.4764 29.6401 29.22 29.8965 28.9037 29.8965H25.5437C25.2274 29.8965 24.9709 29.6401 24.9709 29.3238V25.1238ZM26.1164 25.6965V28.751H28.3309V25.6965H26.1164Z"
        />
        <path d="M35.0128 17.9072H31.6528V22.1072H35.0128V17.9072Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.0801 17.9072C31.0801 17.5909 31.3365 17.3345 31.6528 17.3345H35.0128C35.3291 17.3345 35.5855 17.5909 35.5855 17.9072V22.1072C35.5855 22.4235 35.3291 22.6799 35.0128 22.6799H31.6528C31.3365 22.6799 31.0801 22.4235 31.0801 22.1072V17.9072ZM32.2255 18.4799V21.5345H34.4401V18.4799H32.2255Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.0801 25.1238C31.0801 24.8074 31.3365 24.551 31.6528 24.551H35.0128C35.3291 24.551 35.5855 24.8074 35.5855 25.1238V29.3238C35.5855 29.6401 35.3291 29.8965 35.0128 29.8965H31.6528C31.3365 29.8965 31.0801 29.6401 31.0801 29.3238V25.1238ZM32.2255 25.6965V28.751H34.4401V25.6965H32.2255Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10913 17.9072C6.10913 17.5909 6.36555 17.3345 6.68186 17.3345H10.0419C10.3582 17.3345 10.6146 17.5909 10.6146 17.9072V22.1072C10.6146 22.4235 10.3582 22.6799 10.0419 22.6799H6.68186C6.36555 22.6799 6.10913 22.4235 6.10913 22.1072V17.9072ZM7.25459 18.4799V21.5345H9.46913V18.4799H7.25459Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6 17.9072C12.6 17.5909 12.8564 17.3345 13.1727 17.3345H16.5327C16.849 17.3345 17.1054 17.5909 17.1054 17.9072V22.1072C17.1054 22.4235 16.849 22.6799 16.5327 22.6799H13.1727C12.8564 22.6799 12.6 22.4235 12.6 22.1072V17.9072ZM13.7454 18.4799V21.5345H15.96V18.4799H13.7454Z"
        />
        <path d="M10.0419 25.1235H6.68188V29.3235H10.0419V25.1235Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10913 25.1238C6.10913 24.8074 6.36555 24.551 6.68186 24.551H10.0419C10.3582 24.551 10.6146 24.8074 10.6146 25.1238V29.3238C10.6146 29.6401 10.3582 29.8965 10.0419 29.8965H6.68186C6.36555 29.8965 6.10913 29.6401 6.10913 29.3238V25.1238ZM7.25459 25.6965V28.751H9.46913V25.6965H7.25459Z"
        />
        <path d="M16.5327 25.1235H13.1727V29.3235H16.5327V25.1235Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6 25.1238C12.6 24.8074 12.8564 24.551 13.1727 24.551H16.5327C16.849 24.551 17.1054 24.8074 17.1054 25.1238V29.3238C17.1054 29.6401 16.849 29.8965 16.5327 29.8965H13.1727C12.8564 29.8965 12.6 29.6401 12.6 29.3238V25.1238ZM13.7454 25.6965V28.751H15.96V25.6965H13.7454Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.14551 37.0364C1.14551 36.72 1.40193 36.4636 1.71824 36.4636H39.9001C40.2164 36.4636 40.4728 36.72 40.4728 37.0364C40.4728 37.3527 40.2164 37.6091 39.9001 37.6091H1.71824C1.40193 37.6091 1.14551 37.3527 1.14551 37.0364Z"
        />
      </svg>
    );
  },
);
